import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { PsBeaconNotification } from '../BeaconRegister';

const SelectionError = ({ errors }) => {
    const filteredErrors = errors.filter(err => err.error)
    return (
        <PsBeaconNotification variant='error'>
            {`There ${filteredErrors.length > 1 ? 'are' : 'is'} ${filteredErrors.length} error(s) in this Terms of Service form.`}
            <Box slot='description'>
                <ul>
                    {filteredErrors?.map(error => (
                        <li key={error.section}> At the bottom of {error?.section}, you must select &quot;{error?.content}&quot;</li>
                    ))}
                </ul>
            </Box>
        </PsBeaconNotification>
    )
};

export default SelectionError;
